import PartnerListing from './PartnerListing';

export default PartnerListing;
